import React from 'react'
import moment from 'moment'
import { Card, Button, List, Image, Label } from 'semantic-ui-react'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  card: {
    width: 300,
    minWidth: 300,
    maxWidth: 300,
    marginRight: 10,
    marginBottom: 20,
  },
  image: {
    width: 150,
    height: 150,
  }
}

const Row = ({ field, value, color }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>{field}</div>
        <div style={{ display: 'flex' }}>
          <Label size="medium" color={color}>
            {value}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

export default ({ category, onEditClick, onDeleteClick }) => {
  const createdAt = moment(category.created_at).format('DD-MMM-YYYY')

  return (
    <Card style={styles.card}>
      <Card.Content>
        <Card.Description textAlign="center">
          <Image circular src={category.image_url} style={styles.image} />
          <List verticalAlign="middle" style={{ marginTop: 10 }} divided>
            <Row field="Title" value={category.title} color="green" />
            <Row field="Category" value={category.categoryName} />
            <Row field="Created At" value={createdAt} />
          </List>
        </Card.Description>
      </Card.Content>
      <Card.Content extra textAlign="right">
        <Button.Group fluid>
          <Button onClick={() => onEditClick(category)} size="tiny" content="Edit" />
          <Button onClick={() => onDeleteClick(category)} size="tiny" content="Delete" color="red" />
        </Button.Group>
      </Card.Content>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/containers/appCustomization/components/EntryCategories/card.js